'use client';

import { createContext } from 'react';

import type { TabsRootContextInterface } from '../types/tabs-root.types';

export const TabsRootContext = createContext<TabsRootContextInterface>({});

TabsRootContext.displayName = 'Tabs.Root.Context';
